export const ROOT_PATH = '/';
export const PREVIOUS_PATH = -1;

// root level standalone paths
export const FORGOT_PASSWORD_ROOT_PATH = '/forgot-password';
export const GUEST_BOOK_GUEST_PATH = '/guest-book/:guestId?';
export const RESET_PASSWORD_ROOT_PATH = '/reset-password';
export const INVITE_EXPIRED_PATH = '/invite-expired';
export const CREATE_ACCOUNT_PATH = '/create-account';
export const COVER_FLOW_PATH = '/cover-flow';
export const INBOX_PATH = '/inbox';

// reservations paths
export const RESERVATIONS_ROOT_PATH = '/reservations';
// reservations report paths
export const RESERVATIONS_RESERVATIONS_REPORT_PATH =
  '/reservations/reservations-report';
export const RESERVATIONS_COVERS_REPORT_PATH = '/reservations/covers-report';
// reservations service paths
export const RESERVATIONS_SERVICE_PATH = '/reservations/service';
export const RESERVATIONS_SERVICE_TERMINAL_PATH = 'service';
export const RESERVATIONS_OCCUPANTS_PAGE_PATH = 'occupants';
export const RESERVATIONS_WAITLIST_PAGE_PATH = 'waitlist';
export const RESERVATIONS_SERVERS_PAGE_PATH = 'servers';
// reservations concierge paths
export const RESERVATIONS_CONCIERGE_PATH = '/reservations/concierge';
export const RESERVATIONS_CONCIERGE_MULTIPLE_TABLES_PATH =
  '/reservations/concierge/multiple-tables';
export const RESERVATIONS_CONCIERGE_TERMINAL_PATH = 'concierge';
export const RESERVATIONS_CONCIERGE_MULTIPLE_TABLES_TERMINAL_PATH =
  'concierge/multiple-tables';
// occupants paths
export const RESERVATIONS_OCCUPANTS_PATH = '/reservations/occupants';
export const RESERVATIONS_OCCUPANTS_TERMINAL_PATH = 'occupants';

// operations paths
export const OPERATIONS_ROOT_PATH = '/operations';
// operations listings paths
export const OPERATIONS_LISTINGS_PATH = '/operations/listings';
export const OPERATIONS_LISTINGS_TERMINAL_PATH = 'listings';
export const OPERATIONS_LISTINGS_FLOOR_PLAN_PATH =
  '/operations/listings/floor-plan';
export const OPERATIONS_LISTINGS_FLOOR_PLAN_TERMINAL_PATH = 'floor-plan';
export const OPERATIONS_LISTINGS_FLOOR_PLAN_PUBLISHED_PATH =
  '/operations/listings/floor-plan/published';
export const OPERATIONS_LISTINGS_FLOOR_PLAN_PUBLISHED_TERMINAL_PATH =
  'published';
export const OPERATIONS_LISTINGS_FLOOR_PLAN_INACTIVE_TERMINAL_PATH = 'inactive';
export const OPERATIONS_LISTINGS_FLOOR_PLAN_INACTIVE_PATH =
  '/operations/listings/floor-plan/inactive';
/**
 * @deprecated The listings calendar page is dead! This now redirects to the
 * floor plan page.
 */
export const OPERATIONS_LISTINGS_CALENDAR_TERMINAL_PATH = 'calendar';
// operations listings create/edit paths
export const OPERATIONS_LISTINGS_CREATE_PATH = '/operations/listings/create';
export const OPERATIONS_LISTINGS_CREATE_TERMINAL_PATH = 'create';
export const OPERATIONS_LISTINGS_EDIT_PATH = '/operations/listings/edit';
export const OPERATIONS_LISTINGS_EDIT_TERMINAL_PATH = 'edit';

// operations reservations path
export const OPERATIONS_RESERVATION_TIMELINE_PATH = '/operations/timeline';
export const OPERATIONS_RESERVATION_TIMELINE_TERMINAL_PATH = 'timeline';

// operations bulletins paths
export const OPERATIONS_BULLETIN_BOARD_PATH = '/operations/bulletins';
export const OPERATIONS_BULLETIN_BOARD_TERMINAL_PATH = 'bulletins';
export const OPERATIONS_BULLETIN_BOARD_CREATE_PATH =
  '/operations/bulletins/create';
export const OPERATIONS_BULLETIN_BOARD_CREATE_TERMINAL_PATH = 'create';
export const OPERATIONS_BULLETIN_BOARD_UPDATE_PATH =
  '/operations/bulletins/update';
export const OPERATIONS_BULLETIN_BOARD_UPDATE_TERMINAL_PATH = 'update';

export const OPERATIONS_FLOOR_PLANS_PATH = '/operations/floor-plans';
export const OPERATIONS_FLOOR_PLANS_TERMINAL_PATH = 'floor-plans';

export const OPERATIONS_FLOOR_PLANS_EDIT_PATH =
  '/operations/floor-plans/:floorPlanId/edit';

export const OPERATIONS_SHIFTS_PATH = '/operations/shifts';
export const OPERATIONS_SHIFTS_TERMINAL_PATH = 'shifts';

export const OPERATIONS_PRICING_GRID_PATH = '/operations/pricing';
export const OPERATIONS_PRICING_GRID_TERMINAL_PATH = 'pricing';
export const OPERATIONS_FORECAST_PATH = '/operations/forecast';
export const OPERATIONS_FORECAST_TERMINAL_PATH = 'forecast';
export const OPERATIONS_BUSY_TIMES_PATH = '/operations/busy-times';
export const OPERATIONS_BUSY_TIMES_TERMINAL_PATH = 'busy-times';
export const OPERATIONS_TABLE_RATING_PATH = '/operations/table-rating';
export const OPERATIONS_TABLE_RATING_TERMINAL_PATH = 'table-rating';
export const OPERATIONS_INTEGRATIONS_PATH = '/operations/integrations';
export const OPERATIONS_INTEGRATIONS_TERMINAL_PATH = 'integrations';
export const OPERATIONS_INTEGRATIONS_HOTEL_SYNC_PATH =
  '/operations/integrations/hotel-sync';
export const OPERATIONS_INTEGRATIONS_HOTEL_SYNC_TERMINAL_PATH = 'hotel-sync';

export const OPERATIONS_EVENTS_PATH = '/operations/events';
export const OPERATIONS_EVENTS_TERMINAL_PATH = 'events';

// operations restaurant events paths
export const OPERATIONS_EVENT_DETAIL_TERMINAL_PATH = ':eventId';
export const OPERATIONS_EVENT_DETAIL_NEW_TERMINAL_PATH = 'new';
export const OPERATIONS_EVENT_BOOK_TERMINAL_PATH = ':eventId/book';
export const operationsEventBookPath = (eventId: string) =>
  `${OPERATIONS_EVENTS_PATH}/${eventId}/book`;

export const OPERATIONS_MESSAGING_PATH = '/operations/messaging';
export const OPERATIONS_MESSAGING_TERMINAL_PATH = 'messaging';
export const OPERATIONS_MESSAGING_TEMPLATE_PATH = ':templateId';

// settings paths
export const SETTINGS_ROOT_PATH = '/settings';
// settings general paths
export const SETTINGS_GENERAL_PATH = '/settings/general';
export const SETTINGS_GENERAL_TERMINAL_PATH = 'general';
export const SETTINGS_VIP_PROGRAM_PATH = '/settings/vip-program';
export const SETTINGS_VIP_PROGRAM_TERMINAL_PATH = 'vip-program';
// settings team paths
export const SETTINGS_TEAM_PATH = '/settings/team';
export const SETTINGS_TEAM_TERMINAL_PATH = 'team';
export const SETTINGS_EDIT_TEAM_MEMBER_PATH = '/settings/team-member';
export const SETTINGS_EDIT_TEAM_MEMBER_TERMINAL_PATH = 'team-member';
export const SETTINGS_INVITE_MEMBER_PATH = '/settings/invite-team-member';
export const SETTINGS_INVITE_MEMBER_TERMINAL_PATH = 'invite-team-member';
// settings finances paths
export const SETTINGS_FINANCES_PATH = '/settings/finances';
export const SETTINGS_FINANCES_TERMINAL_PATH = 'finances';

export const SETTINGS_REPORTS_PATH = '/settings/reports';
export const SETTINGS_REPORTS_TERMINAL_PATH = 'reports';

export const SETTINGS_LIGHTSPEED_PATH = '/settings/lightspeed';
export const SETTINGS_LIGHTSPEED_TERMINAL_PATH = 'lightspeed';
export const SETTINGS_LIGHTSPEED_CALLBACK_PATH =
  '/settings/lightspeed/callback';
export const SETTINGS_LIGHTSPEED_CALLBACK_TERMINAL_PATH = 'lightspeed/callback';

export const SUPPORT_ROOT_PATH = '/support';
export const SUPPORT_GUEST_IMPORT_TERMINAL_PATH = 'guest-import';
